import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LookupData } from '../models/lookup';
import { map } from 'rxjs/operators';
import { ApiResult } from '../models/ApiResult';

@Injectable({
  providedIn: 'root'
})
export class ValidacionEditService {

  myAppUrl = '';

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  hasValoracion(id: string) {
    return this._http.get(this.myAppUrl + 'api/Valoracion/' + id);
  }

  getValoracion(id: string) {
    return this._http.get(this.myAppUrl + 'api/Valoracion/Validacion/' + id);
  }

  //postValoracion(id: string): Observable<ApiResult> {
  //  return this._http.get<ApiResult>(this.myAppUrl + 'api/Valoracion/ValidacionNew/' + id);
  //}

  postValoracion(id: string, refCatastroOk: string, dirCorrecta: string, tipCorrecta: string, alturaCorrecta: string) {
    return this._http.get(this.myAppUrl + 'api/Valoracion/ValidacionNew/' + id + '/' + refCatastroOk + '/' + dirCorrecta + '/' + tipCorrecta + '/' + alturaCorrecta);
  }

  delete(id: string) {
    return this._http.get(this.myAppUrl + 'api/Valoracion/Borrar/' + id);
  }
}
